import {GridModel} from '@xh/hoist/cmp/grid';
import {HoistModel, lookup, managed, XH} from '@xh/hoist/core';
import {marketValueCol, pnlDlyCol, pnlYtdCol} from '../../../../cmp/PositionColumns';
import {View} from '@xh/hoist/data';
import {DashViewModel} from '@xh/hoist/desktop/cmp/dash';
import {HoldingsTypeEnum} from '../../../../data/DataTypes';

export class AccountsWidgetModel extends HoistModel {
    @managed gridModel: GridModel;
    @managed view: View;
    @lookup(DashViewModel) dashViewModel: DashViewModel;

    override onLinked() {
        super.onLinked();

        this.persistWith = {dashViewModel: this.dashViewModel};
        this.gridModel = this.createGridModel();
        this.view = this.createView();
    }

    private createView(): View {
        return XH.livePositionsService.cube.createView({
            query: {
                includeRoot: true,
                includeLeaves: false,
                dimensions: ['brokerage', 'portfolioName'],
                filter: {field: 'portfolioHoldingType', op: '!=', value: HoldingsTypeEnum.Cash}
            },
            stores: this.gridModel.store,
            connect: true
        });
    }

    private createGridModel(): GridModel {
        return new GridModel({
            persistWith: this.persistWith,
            store: {projectionOnly: true},
            colChooserModel: true,
            autosizeOptions: {
                mode: 'onDemand'
            },
            treeMode: true,
            expandLevel: 1,
            treeStyle: 'none',
            selModel: 'disabled',
            sortBy: 'cubeLabel',
            rowClassFn: record => {
                if (record.data.cubeLabel == 'Total') return 'totals-row';
            },
            colDefaults: {
                movable: false,
                hideable: false
            },
            columns: [{field: 'cubeLabel', headerName: 'Brokerage', isTreeColumn: true, pinned: true}, marketValueCol, pnlDlyCol, pnlYtdCol],
            contextMenu: null
        });
    }
}
